import axios from './axios';

// 获取热门问答
export const getRecommendationByType = (data: any) => {
    return axios({
        url: 'ticket/v1/category/help-tools',
        method: 'post',
        data,
    });
};

// 更新工单信息
export const updateTicket = (data: any) => {
    return axios({
        url: 'ticket/v1/issue/basic',
        method: 'put',
        data,
    });
};

// 催单
export const remindTicket = (id: string) => axios({
    url: 'ticket/v1/reminder/remind',
    method: 'post',
    data: {id},
});

// 确认工单处理完毕
export const confirmTicket = (id: any) => axios({
    url: 'ticket/v1/issue/confirmed',
    method: 'put',
    data: {issueId: id},
});

// 撤销工单
export const undoTicket = (id: string | number) => axios({
    url: 'ticket/v1/issue/delete',
    method: 'post',
    data: {id},
});

// 删除工单
export const removeTicket = (id: string | number) => {
    return axios({
        url: 'ticket/v1/issue/hide',
        method: 'post',
        data: {id},
    });
};

/**
 * 工单消息已读
 * @param {object} params
 * @param {string} params.issueId 工单id
 * @param {number} params.readTime 时间戳
 */
export const updateIssueReadTime = (params: {issueId: string, readTime: number}) => {
    return axios({
        url: 'ticket/v1/communication/read',
        method: 'put',
        params,
    });
};
/**
 * 获取工单概览数据
 */
export const getTicketOverview = () => axios({
    url: 'ticket/v1/issue/numbers',
});

/**
 * 非[待反馈、待确认]状态的工单回复时调用
 */
export const appendTicketDetail = (data: any) => axios({
    url: 'ticket/v1/communication',
    method: 'post',
    data,
});

export default {
    getTicketList: (data: any) => {
        return axios({
            // url: 'service/ticket/v2/issues',
            url: 'ticket/v1/issue/list',
            method: 'post',
            data: data,
        });
    },

    // 获取订单列表
    getOrderListData: (data: any) => {
        return axios({
            url: 'ticket/v1/fb-order/list',
            method: 'post',
            data: data,
        });
    },

    // 获取催单相关信息
    getRemindInfo: (id: string) => {
        return axios({
            // url: '/service/ticket/reminder/info',
            url: 'ticket/v1/reminder/info',
            method: 'post',
            data: {id},
        });
    },

    // 催单
    remindTicket,

    // 撤销工单
    undoTicket,

    // 删除工单
    removeTicket,

    getTicketDetail: (id: string | number, options: any) => {
        return axios({
            // url: 'service/ticket/info/basic',
            url: 'ticket/v1/issue/basic',
            params: {
                issueId: id,
            },
            headers: {
                ...options,
            },
        });
    },

    getTicketDetailV1: (id: string | number, options: any) => {
        return axios({
            // url: 'service/ticket/detail',
            // method: 'post',
            // data: {
            //     id,
            // },
            url: 'ticket/v1/issue',
            method: 'get',
            params: {
                issueId: id,
            },
            headers: {
                ...options,
            },
        });
    },

    getTicketQuestionTypeList: () => {
        return axios({
            // url: 'service/ticket/questiontype/list',
            // method: 'post',
            url: 'ticket/v1/category/list',
            method: 'get',
        });
    },

    getRecommendationByType,

    // 创建工单
    createTicket: (data: any) => {
        return axios({
            url: 'ticket/v1/issue',
            method: 'post',
            data,
        });
    },

    // 获取工单模板
    getTicketTemplate: (data: any) => {
        return axios({
            // url: 'service/ticket/template',
            url: 'ticket/v1/category/template',
            method: 'post',
            data,
        });
    },

    // 确认工单处理完毕
    confirmTicket,

    // 填写工单处理评价
    evaluateTicket: (data: {
        issueId: string;
        evaluationScore: number;
        tags: number[];
        comment: string;
    }) => {
        return axios({
            url: 'ticket/v2/evaluation',
            method: 'put',
            data,
        });
    },

    // 非[待反馈、待确认]状态的工单回复时调用
    appendTicketDetail,

    // 更新机密信息
    updateSecretInfo: (data: any) => {
        return axios({
            url: 'ticket/v1/secret',
            method: 'post',
            data,
        });
    },

    // hpas实例列表 /api/ticket/v1/instance/hpas/list
    /**
     * 获取hpas实例列表
     * @param data
     * @param data.region 区域
     * @param data.keyword 关键词
     * @param data.keywordType 关键词类型
     * @param data.order 排序
     * @param data.orderBy 排序字段
     */
    getHpasInstances: (data: any) => {
        return axios({
            url: 'ticket/v1/instance/hpas/list',
            method: 'post',
            data,
            headers: {
                'Region': data.region,
            },
        });
    },
    /**
     * 查询BCC的实例列表
     * @param data
     * @returns
     */
    getBccInstances: (data: any) => {
        return axios({
            url: 'bcc/instance/list',
            method: 'post',
            data,
            headers: {
                'x-region': data.region,
            },
        });
    },

    /**
     * 获取实例相应的快照
     * https://console.bce.baidu.com/bcc/?_=1671695075568#/bcc/instance/snapshot?instanceId=5d78565a-ad9a-48fd-a401-a7c68ece63df&id=i-cE5vjUYX
     * @returns
     */
    getInstanceSnapshots: (data: any) => axios({
        url: 'bcc/snapshot/list',
        method: 'POST',
        data,
        headers: {
            commonErrorCatch: false,
        },
    }),

    /**
     * 查询BCD域名列表
     * @param data
     * @returns
     */
    getBcdDomains: (data: any) => {
        return axios({
            url: 'bcd/resources/list',
            method: 'post',
            data,
        });
    },

    /**
     * 查询Eip实例列表
     * @param data
     * @returns
     */
    getEipInstances: (data: any) => {
        return axios({
            url: 'eip/list',
            method: 'post',
            data,
            headers: {
                'x-region': data.region,
            },
        });
    },

    // 导出工单列表
    tickListExportUrl: '/api/ticket/v1/issue/export?keyword=&issueNo=&status=',

    // 获取模板
    getTemplateByFeatureId: (data: any) => {
        return axios({
            // url: 'service/ticket/template-feature',
            url: 'ticket/v1/feature/template',
            method: 'post',
            data,
        });
    },

    // 获取产品模块相关信息
    getModuleInfo: (data: any) => {
        return axios({
            // url: 'service/ticket/module/info',
            url: 'ticket/v1/category/module',
            method: 'post',
            data,
        });
    },

    /**
     * 获取机密信息
     * @param params
     * @param params.issueId 工单id
     * @param params.secretId 机密信息id
     * @returns
     */
    getSecretInfo: (params: {issueId: string, secretId: string}) => axios({
        url: 'ticket/v1/secret',
        method: 'get',
        params,
    }),

    /**
     * 获取工单评价
     * @param issueId 工单id
     * @returns
     */
    getTicketEvaluation: (issueId: string) => axios({
        url: 'ticket/v1/evaluation',
        method: 'get',
        params: {issueId},
    }),

    /**
     * 获取推荐产品
     * @returns
     */
    getRecommendProducts: () => axios({
        url: 'ticket/v1/product/recommend',
        method: 'get',
    }),
    getRecommendProductsV2: () => axios({
        url: 'ticket/v2/product/recommend',
        method: 'get',
    }),

    /**
     * 获取需要授权的实例列表
     * @returns
     */
    getPrepareInstances: (authId: any) => axios({
        url: `ticket/v1/instance-auth/prepare?authId=${authId}`,
    }),

    /**
     * 提交授权请求（包含完成停止授权）
     * @returns
     */
    authInstances: (data: any) => axios({
        url: 'ticket/v1/instance-auth/authorization',
        method: 'PUT',
        data,
    }),

    /**
     * 查询授权密码
     * @returns
     */
    getAuthInstancePassword: (authId: any) => axios({
        url: `ticket/v1/instance-auth/secrets?authId=${authId}`,
        method: 'GET',
    }),

    /**
     * 实例授权列表
     * @returns
     */
    getAuthList: (data: any) => axios({
        url: 'ticket/v1/instance-auth/list',
        method: 'POST',
        data,
    }),

    /**
     * 查询Ls实例列表
     * @param data
     * @returns
     */
    getLsInstances: (data: any) => {
        return axios({
            url: 'v1/ls/list',
            method: 'post',
            data,
            headers: {
                'x-region': data.region,
                commonErrorCatch: false,
            },
        });
    },

    /**
     * 获取Ls实例详情
     * @param data
     * @returns
     */
    getLsInstanceDetail: (data: any) => axios({
        url: 'v1/ls/detail',
        method: 'POST',
        data,
        headers: {
            commonErrorCatch: false,
        },
    }),

    /**
     * 获取Ls镜像列表
     * @param data
     * @returns
     */
    getLsImageList: (data: any) => axios({
        url: 'ls/image/list',
        method: 'POST',
        data,
        headers: {
            commonErrorCatch: false,
        },
    }),

    /**
     * 获取单评价标签集合
     * @returns
     */
    getEvaluateTags: (params: {issueId: string}) => axios({
        url: 'ticket/v1/evaluation/tags',
        method: 'GET',
        params,
    }),

    /**
     * 工具关键词搜索建议内容（产品、问题类型，助手、热门问题等）
     * 用于 1.创建页的问题产品搜索
     * 2.创建页的表单问题描述搜索
     * @param data
     * @param data.fuzzyQuestion 关键词
     * @param data.pageSize 建议内容条数
     */
    getSearchSuggestion: (data: {fuzzyQuestion: string, pageSize: number}) => axios({
        url: 'ticket/v1/category/suggestion',
        method: 'POST',
        data,
    }),

    /**
     * 问题描述联想推荐
     * @param input 用户输入内容
     */
    getIssueSummaryAssociation: (input: string) => axios({
        url: 'v1/znzs/user/recommend/issue-summary-association',
        method: 'GET',
        params: {input},
    }),

    /**
     * 撤销Message
     */
    withdrawMessage: (data: any) => {
        return axios({
            url: 'ticket/v1/communication/withdraw',
            method: 'PUT',
            data: data,
        });
    },
    /**
     * 获取相关产品、提单账号列表，及其对应的工单数量
     */
    getTicketCounts: (data: any) => {
        return axios({
            url: 'ticket/v1/issue/count',
            method: 'POST',
            data,
        });
    },
    /**
     * 获取未关闭服务
     * @param data
     * @param data.pageNo 页码
     * @param data.pageSize 一页数量
     * @param data.typeId 二级类型id
     */
    getUnclosedService: (data: any) => axios({
        url: 'ticket/v1/issue/unclosed',
        method: 'POST',
        data,
    }),

    /**
     * 创建工单表单中问题描述匹配三级类型id（新版）
     * @param data
     * @param data.summary 问题描述
     * @param data.issueTypeId 二级类型id
     */
    getFeatureId: (data: any) => axios({
        url: 'ticket/v1/feature/complete',
        method: 'POST',
        data,
    }),
    /**
     * 快速创建工单中根据输入内容预测产品类型编号
     * @param input 用户输入内容（问题描述）
     */
    getFeatureIdRapid: (input: string) => axios({
        url: 'v1/znzs/user/session/predict-type-by-input',
        method: 'GET',
        params: {input},
    }),
    /**
     * 获取当前智能诊断 session 信息（诊断完成后调用，取 znzsSessionId）
     */
    getZnzsSession: () => axios({
        url: 'v1/znzs/user/session',
        method: 'GET',
    }),
};
